<script lang="ts">
  import AuditLogTable from "@kontextwerk/control-web-frame/shared/modules/activity-log-table"
  import { getAdminApi } from "../../../../../../api/kehrblatt/client"
  import type { OrgaViewFrameContext } from "../../../../context"
  import { frameConfig } from "@kontextwerk/control-web-frame/shared/logic/frame-state"
  import { composeControlActivityCatalog } from "@kontextwerk/control-web-frame/shared/logic/activity"

  const { viewFrameContext } = $props<{
    viewFrameContext: OrgaViewFrameContext
  }>()
  const organization = $derived(viewFrameContext.organization)
  const activityCatalog = $derived(composeControlActivityCatalog($frameConfig?.activity?.catalog))
</script>

{#if organization}
  <AuditLogTable
    title="Protokoll"
    catalog={activityCatalog}
    fetchActivityTypes={async () => (await getAdminApi().activity.listCatalog()).items}
    fetchActivityDetail={(id) => getAdminApi().activity.getEvent(organization.id, id)}
    fetchAuditEvents={(params) => getAdminApi().audit.listForOrg(organization.id, params)}
    fixedOrganizationId={organization.id}
    showOrganizationColumn={false}
  />
{/if}
